import _ from "lodash";
const VIDEO_MP4 = "video/mp4";

const isMediaFileVideo = (mediaContent) =>
  _.get(mediaContent, "file.contentType") === VIDEO_MP4;

export default isMediaFileVideo;
